import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { AvField, AvForm } from 'availity-reactstrap-validation';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Button, Card, CardBody, CardTitle, Col, FormGroup, Label } from 'reactstrap';

import { createDmxController } from '../../store/actions';

class CreateDmxControllerForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      popup: false,
      pop_msg: null,
      pop_err: null,
    };
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { messageDmxController, createDmxControllerError, loadingCreateDmxController } = this.props;
    if (loadingCreateDmxController === false && prevProps.loadingCreateDmxController === true) {
      if (messageDmxController) {
        this.setState({ popup: true, pop_msg: 'Controlador creado correctamente' });
      } else if (createDmxControllerError) {
        this.setState({ popup: true, pop_err: 'No se ha podido crear el controlador' });
      }
    }
  }

  confirmPopup() {
    this.setState({ popup: false });
    this.props.history.push('/dmxControllers');
  }

  handleValidSubmit(event, values) {
    const user = this.state.user;
    values.token = user.token;
    this.props.createDmxController(values);
  }

  render() {
    return (
      <Col lg="12">
        <Card>
          <CardBody>
            <CardTitle className="mb-4">{this.props.t('Crear controlador DMX')}</CardTitle>
            <AvForm className="needs-validation" onValidSubmit={this.handleValidSubmit}>
              <Col>
                <FormGroup>
                  <Label htmlFor="dmxControllerName">{this.props.t('Nombre')}</Label>
                  <AvField
                    name="name"
                    placeholder={this.props.t('Nombre')}
                    type="text"
                    errorMessage="Introduzca un nombre válido"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="dmxControllerName"
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="dmxControllerIp">{this.props.t('Ip')}</Label>
                  <AvField
                    name="ip"
                    placeholder="xxx.xxx.xxx.xxx"
                    type="text"
                    errorMessage="Introduzca una ip válida"
                    className="form-control"
                    validate={{
                      required: { value: true, errorMessage: 'Campo obligatorio' },
                      pattern: { value: /^([0-9]{1,3}\.){3}[0-9]{1,3}$/, errorMessage: 'Introduzca una IP válida' },
                    }}
                    id="dmxControllerIp"
                  />
                </FormGroup>
              </Col>
              <Button color="primary" type="submit">
                {this.props.t('Crear controlador')}
              </Button>
            </AvForm>
            {this.state.popup ? (
              <SweetAlert
                type={this.state.pop_msg ? 'success' : 'error'}
                confirmBtnBsStyle={this.state.pop_msg ? 'success' : 'danger'}
                title={this.state.pop_msg ? this.state.pop_msg : this.state.pop_err}
                confirmBtnText={this.props.t('ok')}
                onConfirm={() => this.confirmPopup()}
              ></SweetAlert>
            ) : null}
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const mapStateprops = (state) => {
  const { createDmxControllerError, messageDmxController, loadingCreateDmxController } = state.createDmxController;
  return { createDmxControllerError, messageDmxController, loadingCreateDmxController };
};

export default withRouter(connect(mapStateprops, { createDmxController })(withNamespaces()(CreateDmxControllerForm)));
